import ChildOptionQuantityEditor from './ChildOptionQuantityEditor';

export default ChildOptionQuantityEditor;
